"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../Icon"));
var FormatText_1 = __importDefault(require("../FormatText"));
var TabItem = function (props) {
    var icon = props.icon, text = props.text;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Icon_1.default, { name: icon || 'commons-settings' }),
        react_1.default.createElement(FormatText_1.default, { id: text, uppercase: true })));
};
exports.default = TabItem;
